import { useState, useEffect } from "react";
import {
  signinAdmin,
  sendInvitation
} from "../api/admin";

const useAdmin = () => {
  const [loadingAuthAdmin, setLoadingAuthAdmin] = useState(false);
  const [loadingReceiptEmail, setLoadingReceiptEmail] = useState(false);
  const [signInAdmin, setSignInAdmin] = useState(false);
  const [receiptEmail, setReceiptEmail] = useState(null);
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);

  const getSigninAdmin = async (credentials) => {
    setLoadingAuthAdmin(true);
    setError(null);
    try {
      const response = await signinAdmin(credentials);
      if (response.error) throw new Error(response.error);

      if (response.token) {
        sessionStorage.setItem("authTokenAdmin", response.token);
        setSignInAdmin(true);
      }

      return response;
    } catch (error) {
      setError(error.message);
      throw error;
    } finally {
      setLoadingAuthAdmin(false);
    }
  };

  const getReceiptEmail = async (email) => {
    setLoadingReceiptEmail(true);
    setError(null);
    try {
      const response = await sendInvitation(email);
      return response;
    } catch (error) {
      setError(error.message);
      throw error;
    } finally {
      setLoadingReceiptEmail(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authTokenAdmin");
    if (token) {
      setSignInAdmin(true);
      return;
    }
  }, []);

  return {
    receiptEmail,
    setReceiptEmail,
    credentials,
    setCredentials,
    error,
    setError,
    loadingAuthAdmin,
    loadingReceiptEmail,
    signInAdmin,
    setSignInAdmin,
    getSigninAdmin,
    getReceiptEmail,
  };
};

export default useAdmin;
